<template>
  <ul class="text-orange leading-normal">
    <li
      v-for="item in items"
      :key="item.id"
      class="cursor-pointer"
      @click="item.onClick"
    >
      {{ item.text }}
    </li>
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'BaseBulletList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
